// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//

// Map size and padding.
export const mapSize = {
  width_px: '600px',
  width: 600,
  height_px: '600px',
  height: 600,
  pad: '10px',
};

export default mapSize;